import { Badge } from "@/components/ui/badge";
import { PersonType } from "@/hooks/usePeople";
import { cn } from "@/lib/utils";
import { Briefcase, UserCog, Contact } from "lucide-react";

const personTypeConfig: Record<
  PersonType,
  {
    label: string;
    variant: "default" | "secondary" | "destructive" | "outline";
    className: string;
    icon: React.ElementType;
  }
> = {
  employee: {
    label: "Employee",
    variant: "outline",
    className: "border-blue-500 text-blue-600 bg-blue-50 dark:bg-blue-950/20",
    icon: Briefcase,
  },
  freelancer: {
    label: "Freelancer",
    variant: "outline",
    className:
      "border-violet-500 text-violet-600 bg-violet-50 dark:bg-violet-950/20",
    icon: UserCog,
  },
  contact: {
    label: "Contact",
    variant: "secondary",
    className: "bg-muted text-muted-foreground",
    icon: Contact,
  },
};

interface PersonTypeBadgeProps {
  type: PersonType;
  showIcon?: boolean;
  className?: string;
}

export function PersonTypeBadge({
  type,
  showIcon = true,
  className,
}: PersonTypeBadgeProps) {
  const config = personTypeConfig[type];
  const Icon = config.icon;

  return (
    <Badge
      variant={config.variant}
      className={cn(config.className, "gap-1", className)}
    >
      {showIcon && <Icon className="h-3 w-3" />}
      {config.label}
    </Badge>
  );
}
